<template>
    <v-container class="mb-5 mt-0 pa-8">
        <p>Brand Settings <small>- These are for reporting - they won't change the actual platform settings</small></p>
        <v-row>
            <v-col cols="6" md="6">
                <v-text-field outlined v-model="brandData.logoUrl" name="Logo Url" type="text" label="Logo Url"></v-text-field>
            </v-col>
            <v-col cols="6" md="2">
                <div v-if="brandData.logoUrl != null" class="mb-3 py-2" :style="{ 'background-color': brandData.primaryColour.hex }">
                    <img width="100%" mx="auto" :src="brandData.logoUrl" alt="logo image example">
                </div>
            </v-col>
            <v-col cols="6" md="2">
                <div v-if="brandData.logoUrl != null" class="mb-3">
                    <v-btn elevation="0" class="button-style" :style="{ 'background-color': brandData.buttonColour.hex, 'color': brandData.buttonTextColour.hex }">Example Button</v-btn>
                </div>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="6" md="2">
                <div class="color-pickers">
                    <p class="color-picker-text">Header</p>
                    <br>
                    <v-input>
                        <chrome-picker v-model="brandData.primaryColour" />
                    </v-input>
                </div>
            </v-col>
            <v-col cols="6" md="2">
                <div class="color-pickers">
                    <p class="color-picker-text">Header-text</p>
                    <br>
                    <v-input>
                        <chrome-picker v-model="brandData.secondaryColour" />
                    </v-input>
                </div>
            </v-col>
            <v-col cols="6" md="2">
                <div class="color-pickers dark">
                    <p class="color-picker-text">Button</p>
                    <br>
                    <v-input>
                        <chrome-picker v-model="brandData.buttonColour" />
                    </v-input>
                </div>
            </v-col>
            <v-col cols="6" md="2">
                <div class="color-pickers">
                    <p class="color-picker-text">Button-text</p>
                    <br>
                    <v-input>
                        <chrome-picker v-model="brandData.buttonTextColour" />
                    </v-input>
                </div>
            </v-col>
            <v-col cols="6" md="2">
                <div class="color-pickers">
                    <p class="color-picker-text">Background</p>
                    <br>
                    <v-input>
                        <chrome-picker v-model="brandData.backgroundColour" />
                    </v-input>
                </div>
            </v-col>
            <v-col cols="6" md="2">
                <div class="color-pickers">
                    <p class="color-picker-text">Foreground</p>
                    <br>
                    <v-input>
                        <chrome-picker v-model="brandData.foregroundColour" />
                    </v-input>
                </div>
            </v-col>
            <v-col cols="12">
                <v-btn elevation="0" class="button-style" v-if="!brandSet" @click="setClient" color="primary"> 
                    Set Branding
                </v-btn>
                <v-btn elevation="0" class="button-style" v-if="brandSet" @click="updateClient" color="primary"> 
                    Update Branding
                </v-btn>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import moment from 'moment'
import { Chrome } from 'vue-color'
import { VueEditor } from 'vue2-editor'
    export default {
        name: 'ClientDetails',
        data(){
            return {
                id: this.$route.params.id,
                brandSet: false,
                brandData: {
                    logoUrl: null,
                    primaryColour: '#ffffff',
                    secondaryColour: '#ffffff',
                    buttonColour: '#ffffff',
                    buttonTextColour: '#ffffff',
                    backgroundColour: '#ffffff',
                    foregroundColour: '#ffffff'
                }
            }
        },
        components: {
            'chrome-picker': Chrome
        },
        methods: {
            getClient(){
                firebase.firestore().collection('clients').doc(this.id).collection('branding').doc('reporting').onSnapshot(docSnapshot => {
                    if(docSnapshot.data()){
                        this.brandData = docSnapshot.data()
                        this.brandSet = true
                    }else{
                        this.brandSet = false
                    }
                }, err => { console.log(`Encountered error: ${err}`) })
            },
            setClient(){
                firebase.firestore().collection('clients').doc(this.id).collection('branding').doc('reporting').set({
                    logoUrl: this.brandData.logoUrl,
                    primaryColour: this.brandData.primaryColour,
                    secondaryColour: this.brandData.secondaryColour,
                    buttonColour: this.brandData.buttonColour,
                    buttonTextColour: this.brandData.buttonTextColour,
                    backgroundColour: this.brandData.backgroundColour,
                    foregroundColour: this.brandData.foregroundColour
                }).then(() => {
                    this.brandSet = true
                })
            },
            updateClient(){
                firebase.firestore().collection('clients').doc(this.id).collection('branding').doc('reporting').update({
                    logoUrl: this.brandData.logoUrl,
                    primaryColour: this.brandData.primaryColour,
                    secondaryColour: this.brandData.secondaryColour,
                    buttonColour: this.brandData.buttonColour,
                    buttonTextColour: this.brandData.buttonTextColour,
                    backgroundColour: this.brandData.backgroundColour,
                    foregroundColour: this.brandData.foregroundColour
                })
            }
        },
        mounted(){
            this.getClient()
        }
    }
</script>

<style>
#input__label__hex__106{
    display: none;
}
.vc-chrome-toggle-btn{
    display: none;
}
.vc-input__input{
    color: #e2e2e2 !important;
}
.vc-chrome{
    box-shadow: 0 0 0px rgba(255, 255, 255, 0), 0 0px 0px rgba(255, 255, 255, 0) !important;
    margin: 0px auto;
}
.vc-chrome-body{
    background-color: #424242;
    border-radius: 0px 0px 12px 12px;
}
.color-pickers{
    text-align: center;
    margin-top: -15px;
    width: 100%;
}
.color-picker-text{
    margin-bottom: -10px;
}
</style>